export default __webpack_public_path__ + "static/media/save-img-1.7ba7b0f7.jpg";